import { apiClient } from './axiosInstance';
import { ensureOk, toFormData } from '../helpers/api-helper';
import { ApiEnvelope } from '@/types/apiEnvelope';
import { MeProfile, MeProfileEdit, UpdateProfilePayload } from '@/types/meProfile';

export const MeService = {
  async getMeInfo() {
    const { data } = await apiClient.get<ApiEnvelope<MeProfile>>('/me');
    const result = ensureOk<MeProfile>(data);
    return result;
  },

  async getMeEditInfo() {
    const { data } = await apiClient.get<ApiEnvelope<MeProfileEdit>>('/me/edit');
    const result = ensureOk<MeProfileEdit>(data);
    return result;
  },

  async updateMeEditInfo(payload: UpdateProfilePayload) {
    const {
      name,
      womo_id,
      bday,
      gender,
      county,
      facebook_url,
      instagram_url,
      youtube_url,
      tik_tok_url,
      banner_introduction,
      tag,
      image,
    } = payload;

    const fd = toFormData({
      name,
      womo_id,
      bday,
      gender,
      county,
      facebook_url,
      instagram_url,
      youtube_url,
      tik_tok_url,
      banner_introduction,
      image,
    });

    tag.forEach((t) => {
      fd.append('tag[]', t);
    });

    for (const [key, value] of fd.entries()) {
      console.log(key, value);
    }

    await apiClient.post<ApiEnvelope>('/me', fd);
  },
};
